module.exports = __webpack_public_path__ + "img/ezcms.8b917cff.png";